const localToUtc = (dateTime: string) => new Date(dateTime).toUTCString();

export default localToUtc;
